import { createAsyncThunk } from '@reduxjs/toolkit';
import { StateType } from '../../../types';
import formAPI from '../api/form';

type ReferralHeinzvonHeidenFormType = {
  type: string;
  profile: string;
  consulting: boolean;
  newsletter: boolean;
  others: boolean;
  comment: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phone: string;
  invitationUrl: string;
  reviewId: string;
};

export const referralFormHeinzvonHeidenRequested = createAsyncThunk(
  'LANDING_REFERRAL_HEINZVON_HEIDEN/FORM_REQUESTED',
  async (data: ReferralHeinzvonHeidenFormType, store) => {
    const state = store.getState() as StateType;
    const response = await formAPI(state).getForm(data);

    return response;
  },
);
